import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { AccountBidderStatus } from "@m19-board/services/account-settings.service";
import { AccountStatusBadgeComponent } from "@m19-board/settings/account-settings/account-status-badge/account-status-badge.component";

@Component({
  selector: "app-account-bidder-status-formatter",
  imports: [AccountStatusBadgeComponent],
  host: {
    class: "flex gap-2",
  },
  template: `
    <app-account-status-badge [accountBidderStatus]="values()[0]" noTooltip />
    @if (values().length > 1) {
      {{ label() }}
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountBidderStatusFormatterComponent {
  readonly values = input.required<AccountBidderStatus[]>();

  readonly label = computed(() => {
    return this.values().length > 1 ? `(+${this.values().length - 1})` : "";
  });
}
